<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Store",
    data() {
        return {
            msg: 'Shelf Here',
        }
    },
}
</script>

<style scoped>

</style>
